import { blue20 } from '../../../colors/blue';
export var MuiBreadcrumbs = {
    styleOverrides: {
        ol: {
            color: blue20,
        },
    },
};
